/** Layout roles. Control and state styling lives in @workspace/blocks/ui. */
export const pageShell = "mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8";
export const pageContainer = pageShell;
export const pageMain = "py-8 sm:py-12";
export const panel = "ui-panel";
export const heroPanel = "p-6 sm:p-8";
export const headerShell = "mx-auto flex min-h-16 w-full max-w-7xl items-center justify-between gap-4 px-4 sm:px-6 lg:px-8";
export const pageBg = "min-h-screen bg-background text-foreground";
export const footerShell = "mt-auto border-t border-border bg-background py-6";
